<template>
  <div class="col s12 l6 edit">
    <div>
      <div class="page-subtitle">
        <h4>{{'Edit' | localize}}</h4>
      </div>

      <form @submit.prevent="submitHandler">
        <div class="input-field">
          <select ref="select" v-model="current">
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >{{category.title}}</option>
          </select>
          <label>{{'SelectCategory' | localize}}</label>
        </div>

        <div class="input-field">
          <input
            type="text"
            id="name"
            v-model.trim="CategoryName"
            :class="{invalid: $v.CategoryName.$dirty && !$v.CategoryName.required}"
          />
          <label for="name">{{'Title' | localize}}</label>
          <span
            v-if="$v.CategoryName.$dirty && !$v.CategoryName.required"
            class="helper-text invalid"
          >{{'Message_NewCategoryTitle' | localize}}</span>
        </div>

        <div class="input-field">
          <input
            id="limit"
            type="number"
            v-model.number="CategoryLimit"
            :class="{invalid: ($v.CategoryLimit.$dirty && !$v.CategoryLimit.minValue) || ($v.CategoryLimit.$dirty && !$v.CategoryLimit.required)}"
          />
          <label for="limit">{{'Limit' | localize}}</label>
          <span
            v-if="$v.CategoryLimit.$dirty && !$v.CategoryLimit.required"
            class="helper-text invalid"
          >{{'Message_NewCategoryLimit' | localize}}</span>
          <span
            class="helper-text invalid"
            v-if="$v.CategoryLimit.$dirty && !$v.CategoryLimit.minValue"
          >{{'Message_MinLength' | localize}}: {{$v.CategoryLimit.$params.minValue.min}}</span>
        </div>

        <button class="btn waves-effect waves-light" type="submit">
          {{'Update' | localize}}
          <i class="material-icons right">autorenew</i>
        </button>
      </form>
    </div>
  </div>
</template>

<style scoped>
@media screen and (max-width: 992px) {
  .edit {
    margin-top: 30px;
  }
}
</style>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import localizeFilter from "@/filters/localize.filter";

export default {
  name: "CategoryEdit",
  props: ["categories"],
  data: () => ({
    select: null,
    current: null,
    CategoryName: "",
    CategoryLimit: 100
  }),
  validations: {
    CategoryName: { required },
    CategoryLimit: { required, minValue: minValue(100) }
  },
  mounted() {
    window.M.updateTextFields();
    this.select = window.M.FormSelect.init(this.$refs.select);
  },
  destroyed() {
    if (this.select && this.select.destroy) {
      this.select.destroy();
    }
  },
  watch: {
    current(catId) {
      const { title, limit } = this.categories.find(c => c.id === catId);
      this.CategoryName = title;
      this.CategoryLimit = limit;
    }
  },
  created() {
    const { id, title, limit } = this.categories[0];
    this.current = id;
    this.CategoryName = title;
    this.CategoryLimit = limit;
  },
  methods: {
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      try {
        const categoryData = {
          id: this.current,
          title: this.CategoryName,
          limit: this.CategoryLimit
        };
        await this.$store.dispatch("updateCategory", categoryData);
        this.$message(localizeFilter("Category_HasBeenUpdated"));
        await this.$emit("updated", categoryData);
        window.M.updateTextFields();
        this.$nextTick(() => {
          this.select = window.M.FormSelect.init(this.$refs.select);
        });
      } catch (e) {}
    }
  }
};
</script>